export type ParsedQuery = URLSearchParams;

export const getQueryParams = (): URLSearchParams => {
    return new URLSearchParams(window.location.search);
};
